var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromptLib(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_59625_17630",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_59625_17630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8655 21.5C6.218 21.5 5.66192 21.2827 5.19725 20.848C4.73242 20.4135 4.5 19.8757 4.5 19.2345V5.58274C4.5 5.00707 4.68625 4.49649 5.05875 4.05099C5.43108 3.60549 5.90508 3.32249 6.48075 3.20199L15.8077 1.29999V16.6077L6.6405 18.5172C6.46483 18.5571 6.31417 18.6427 6.1885 18.774C6.06283 18.9055 6 19.059 6 19.2345C6 19.4563 6.08625 19.6394 6.25875 19.7837C6.43108 19.9279 6.63333 20 6.8655 20H18V4.49999H19.5V21.5H6.8655ZM8.69225 16.579L14.3077 15.4115V3.14424L8.69225 4.29224V16.579ZM7.19225 16.8827V4.59624L6.7885 4.68074C6.56033 4.7269 6.37183 4.83174 6.223 4.99524C6.07433 5.15874 6 5.35457 6 5.58274V17.229C6.1025 17.1763 6.20767 17.1311 6.3155 17.0932C6.42317 17.0554 6.5315 17.025 6.6405 17.002L7.19225 16.8827Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptLib);
export default __webpack_public_path__ + "static/media/promptLib.0eb4250db74ac1edfc452ed26a52b170.svg";
export { ForwardRef as ReactComponent };